// @ts-nocheck
document.addEventListener("alpine:init", () => {
    Alpine.data("collectionTabs", ({ initialTab }) => ({
        tab: initialTab,
        loaded: [initialTab],
        allLoaded: {},

        switchTab(handle) {
            if (!this.loaded.includes(handle)) {
                this.loadTab(handle);
            }
            this.tab = handle;
        },

        loadTab(handle) {
            const template = document.querySelector(`[data-template="${handle}"]`);
            const panel = document.querySelector(`[data-collection="${handle}"]`);
            const grid = panel ? panel.querySelector('[data-grid]') : null;

            if (template && grid && grid.children.length === 0) {
                const content = template.content.cloneNode(true);
                grid.appendChild(content);
                this.loaded.push(handle);
            }
        },

        loadMore(handle) {
            if (this.allLoaded[handle]) return;

            const template = document.querySelector(`[data-more="${handle}"]`);
            const panel = document.querySelector(`[data-collection="${handle}"]`);
            const grid = panel ? panel.querySelector('[data-grid]') : null;

            if (template && grid) {
                const content = template.content.cloneNode(true);
                grid.appendChild(content);
                this.allLoaded[handle] = true;
            }
        }
    }));
});
